import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import * as Highcharts from "highcharts";
import Highcharts3D from 'highcharts/highcharts-3d';
import { SalesTrendsPopupInfoComponent } from "src/app/modules/analytics/sales-trends-popup-info/sales-trends-popup-info.component";
import { Subject } from "rxjs";

Highcharts3D(Highcharts);

@Component({
  selector: "app-doughnut-chart",
  templateUrl: "./doughnut-chart.component.html",
  styleUrls: ["./doughnut-chart.component.scss"],
})
export class DoughnutChartComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() id: string;
  @Input() data: any[];
  @Input() chartColors: string[];
  @Input() yAxisLabelType: string;
  @Input() labels: any;
  @Input() SalesTrendsData: any;
  @Input() isProductDashboard: boolean = false;
  @Input() isShowTitleOnly: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.drawDoughnutChart();
  }

  ngOnInit(): void {
    this.drawDoughnutChart();
  }

  ngAfterViewInit(): void {
    this.drawDoughnutChart();
  }

  public drawDoughnutChart() {
    const yAxisType = this.yAxisLabelType;
    Highcharts.setOptions({
      colors: this.chartColors,
      lang: {
        thousandsSep: ',',
      }
    });

    const options: Highcharts.Options = {
      chart: {
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'transparent',
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0,
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
        style: {
          fontSize: "24px",
        },
      },
      yAxis: {
        labels: {
          formatter: function () {
            return String(yAxisType === "percentage"
              ? this.value + "%"
              : yAxisType === "dollar"
                ? "$" + this.value
                : this.value);
          },
        },
      },
      tooltip: {
        useHTML: true,
        enabled: this.SalesTrendsData ? false : true,
        style: {
          color: this.isProductDashboard ? "black" : "white",
        },
        backgroundColor: this.isProductDashboard ? 'white' : "black",
        headerFormat: '',
        pointFormat: this.isProductDashboard ? '<div > <span style="background-color: {point.color}; width: 10px; height: 10px; display: inline-block;"></span> {point.name}: {point.y}</div>'
          : '<div > <span style="background-color: {point.color}; width: 10px; height: 10px; display: inline-block;"></span> {point.name}: ${point.y:,.2f}</div>'
      },
      plotOptions: {
        pie: {
          shadow: false,
          center: ["50%", "50%"],
          innerSize: this.isProductDashboard ? "50%" : "50%",
          depth: 45,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            distance: 10,
            style: {
              fontSize: this.isShowTitleOnly ? '12px' : '10px',
              fontWeight: this.isShowTitleOnly ? '600' : '400',
            },
            format: this.isShowTitleOnly ? '{point.name}' : this.isProductDashboard ? '{point.name}<br>{point.y}' : '<span>{point.name}</span><br><span style="font-weight: 500; font-family: var(--font-primary)">${point.y:,.2f}</span>'
          },
        }
      },
      series: [
        {
          size: this.SalesTrendsData ? "140%" : this.isProductDashboard ? "116%" : "110%",
          type: "pie",
          innerSize: '50%',
          data: this.data,
          events: {
            click: this.SalesTrendsData ? this.openSalesTrendPopup.bind(this) : ''
          },
        },
      ],
    };

    Highcharts.chart(this.id, options);
  }

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosition = target.getBoundingClientRect();
    return {
      bottom:
        targetPosition.bottom < 612 ? targetPosition.bottom + "px" : "612px",
      left: targetPosition.left + "px",
      right: targetPosition.right + "px",
      top: targetPosition.top + 50 + "px",
    };
  }

  openSalesTrendPopup(event) {
    const trend = event.point.name;
    this.dialog.open(SalesTrendsPopupInfoComponent, {
      width: "260px",
      backdropClass: "cdk-overlay-transparent-backdrop",
      position: {
        left: event.screenX + "px",
        right: event.screenY + "px",
        top: "260px"
      },
      data: {
        title: trend,
        data: this.SalesTrendsData
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
